module.exports = __webpack_public_path__ + "img/serve-up.58052ecc.svg";